module.exports = __webpack_public_path__ + "img/logo.bb2e3ee1.svg";